import React from 'react'

export default function AnswerButton({ label, selected, onClick, isSkip }) {
  const modifier = selected ? (isSkip ? 'questionnaire-step__answer-btn--skip-selected' : 'questionnaire-step__answer-btn--selected') : ''
  return (
    <button
      type="button"
      onClick={onClick}
      className={`questionnaire-step__answer-btn ${modifier}`}
    >
      {label}
    </button>
  )
}
